// extracted by mini-css-extract-plugin
module.exports = {"button":"TileFooter_button__1O22B","text":"TileFooter_text__3ZdBE","arrowIcon":"TileFooter_arrowIcon__30SkH"};